// extracted by mini-css-extract-plugin
export default {"vehicleInfo":"VehicleInfo_vehicleInfo__V84+Q","vehicleIcon":"VehicleInfo_vehicleIcon__jvB7G","carNo":"VehicleInfo_carNo__fba9E"};